// extracted by mini-css-extract-plugin
module.exports = {"activity-body-collapse":"activity-body-collapse___24b-7","closed":"closed___2c81M"};